/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @license Simplified BSD License
 */

export const createPackageAvailabilityCheck = (core) => {
  const user = core.getUser();
  const permissions = core.config('packages.permissions', {});

  const checkMetadataGroups = iter => {
    const m = iter.strictGroups === false ? 'some' : 'every';

    return iter.groups instanceof Array
      ? iter.groups[m](g => user.groups.indexOf(g) !== -1)
      : true;
  };

  const checkConfigGroups = iter => {
    const perm = permissions[iter.name];
    if (perm && perm.groups instanceof Array) {
      const m = perm.strictGroups === false ? 'some' : 'every';
      return perm.groups[m](g => user.groups.indexOf(g) !== -1);
    }

    return true;
  };

  const checkBlacklist = iter => user.blacklist instanceof Array
    ? user.blacklist.indexOf(iter.name) === -1
    : true;

  const checks =  [
    checkMetadataGroups,
    checkConfigGroups,
    checkBlacklist
  ];

  return metadata => checks.every(fn => fn(metadata));
};

export const createManifestFromArray = list => list
  .map(iter => ({
    type: 'application',
    ...iter,
    files: (iter.files || [])
      .map(file =>
        typeof file === 'string'
          ? {filename: file, type: 'preload'}
          : {type: 'preload', ...file}
      )
  }));

export const filterMetadataFilesByType = (files, type) =>
  (files || []).filter(file => file.type === type);

export const metadataFilesToFilenames = files =>
  (files || []).map(file => file.filename);
